<ng-container *ngIf="items | TitleFilterPipe: searchTerm as result">
  <div class="header">
    <div [inlineSVG]="getIcon()" class="icon"></div>
    <span class="title"
      ><span class="count">{{ result.length }}</span
      >{{ title | uppercase }}</span
    >
  </div>
  <div class="line"></div>
  <ul class="items">
    <evrideo-recording-asset-item
      *ngFor="let item of result"
      [item]="item"
      (createPreview)="createPreviewFromManager.emit($event)"
      (createRecordingJob)="createRecordingJobFromManager.emit($event)"
      (navigateToSchduler)="navigateToSchdulerFromManager.emit($event)"
    ></evrideo-recording-asset-item>
  </ul>
</ng-container>
